import { render } from "./ErrorComponentNew.vue?vue&type=template&id=5fa431f3&scoped=true"
import script from "./ErrorComponentNew.vue?vue&type=script&lang=js"
export * from "./ErrorComponentNew.vue?vue&type=script&lang=js"

import "./ErrorComponentNew.vue?vue&type=style&index=0&id=5fa431f3&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa431f3"]])

export default __exports__